"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
var drinkCardRouter = {
  path: '/drinkCard',
  component: _layout.default,
  redirect: '/drinkCard/list',
  name: 'drinkCard',
  alwaysShow: true,
  meta: {
    title: '畅饮卡',
    icon: 'drinkCard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/basic/drinkCard'));
      });
    },
    name: 'drinkCardList',
    meta: {
      title: '畅饮卡管理',
      icon: ''
    }
  }, {
    path: 'order',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/basic/drinkCardOrder'));
      });
    },
    name: 'drinkCardOrder',
    meta: {
      title: '畅饮卡订单',
      icon: ''
    }
  }, {
    path: 'refund',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/basic/drinkCardRefund'));
      });
    },
    name: 'drinkCardRefund',
    meta: {
      title: '畅饮卡退款单',
      icon: ''
    }
  }]
};
var _default = exports.default = drinkCardRouter;